

<!-- Feedback Section -->
<div class="section">
  <div class="section-header">
    Feedback
  </div>

  <!-- Toolbar -->
  <nz-row nzJustify="space-between" nzAlign="middle" class="action-bar">
    <nz-col>
      <input
        nz-input
        placeholder="Search Feedback..."
        [(ngModel)]="searchValueFeedback"
        (ngModelChange)="onSearchFeedback()"
      />
    </nz-col>
    <nz-col>
      <button nz-button nzType="primary" (click)="onAddFeedback()">
        Add Feedback
      </button>
    </nz-col>
  </nz-row>

  <!-- Table -->
  <nz-spin [nzSpinning]="loadingFeedback" [nzTip]="'Loading feedback...'">
    <div class="table-container">
      <nz-table
        [nzData]="feedbackList"
        [nzBordered]="true"
        [nzSize]="'middle'"
        [nzShowPagination]="false"
        [nzScroll]="{ x: '1200px' }"
      >
        <thead>
          <tr>
            <th nzWidth="30%">Vendor Name</th>
            <!-- <th nzWidth="30%">Event Name</th> -->
            <th nzWidth="20%">Feedback</th>
            <th nzWidth="15%">Rating</th>
            <th nzWidth="15%">Created By</th>
            <th>Created At</th>
            <th *ngIf="hasActionsColumn">Actions</th>
           </tr>
        </thead>
        <tbody>
          <tr *ngFor="let feedback of feedbackList">
            <td>{{ feedback.vendor_name }}</td>
            <!-- <td>{{ feedback.event_name }}</td> -->
            <td>{{ feedback.feedback }}</td>
            <td>
              <nz-rate
                [ngModel]="feedback.rating / 2"
                [nzCount]="5"
                [nzAllowHalf]="true"
                [nzDisabled]="true"
              ></nz-rate>
            </td>
            <td>
                <span class="user-avatar" style="margin-right: 2px;">
                  {{ feedback.created_by_name ?   feedback.created_by_name[0].toUpperCase() : '?' }}
                </span>
                <span class="user-name">
                  {{ feedback.created_by_name ? feedback.created_by_name :'&nbsp;-' }}
                </span>

              <!-- {{ feedback.created_by_name }} -->
            </td>
            <td>{{ feedback.created_at | date: 'mediumDate' }}</td>

             <td *ngIf="feedback.created_by === loginModel.value.user.id">
              <button nz-button (click)="onEditFeedback(feedback)" [nzSize]="'small'">
                <i nz-icon nzType="edit"></i>
              </button>
              <button
                nz-button
                nzDanger
                [nzSize]="'small'"
                style="margin-left: 10px"
                [nz-popconfirm]="deleteFeedbackPopconfirm"
                [nzPopconfirmTitle]="''"
                [nzPopconfirmOverlayClassName]="'custom-popconfirm-popover'"
                nzPopconfirmPlacement="bottom"
                (nzOnConfirm)="deleteFeedback(feedback)"
              >
                <i nz-icon nzType="delete"></i>
              </button>
            <!-- Custom Popconfirm Template for Feedback Delete -->
            <ng-template #deleteFeedbackPopconfirm>
              <div class="custom-popconfirm-header">
                <span class="custom-popconfirm-title">Confirm Deletion</span>
              </div>
              <div class="custom-popconfirm-icon-area">
                <span style="display: flex; justify-content: center; margin: 18px 0 8px 0;">
                  <nz-icon nzType="warning-fill" nzTheme="fill" style="font-size: 32px; color: #ff6c6c;"></nz-icon>
                </span>
              </div>
              <div class="custom-popconfirm-message description">
                Are you sure you want to delete this feedback?<br />
                <span style="color:#888; font-size:14px;">This action cannot be undone.</span>
              </div>
              <!-- <div class="custom-popconfirm-actions" style="display: flex; justify-content: flex-end; gap: 8px; margin-top: 16px;">
                <button nz-button nzType="default" nzSize="small" (click)="$event.stopPropagation(); deleteFeedbackPopconfirm.cancel()">Cancel</button>
                <button nz-button nzType="primary" nzDanger nzSize="small" (click)="$event.stopPropagation(); deleteFeedbackPopconfirm.confirm()">OK</button>
              </div> -->
            </ng-template>
            </td>
          </tr>
        </tbody>
      </nz-table>
    </div>
  </nz-spin>
</div>

<!-- Notes Section -->
<div class="section" style="margin-top: 20px;">
  <div class="section-header">
    Notes
  </div>

  <!-- Toolbar -->
  <nz-row nzJustify="space-between" nzAlign="middle" class="action-bar">
    <nz-col>
      <input
        nz-input
        placeholder="Search Notes..."
        [(ngModel)]="searchValue"
        (ngModelChange)="onSearch()"
      />
    </nz-col>
    <nz-col>
      <button nz-button nzType="primary" (click)="onAdd()">Add Note</button>
    </nz-col>
  </nz-row>

  <!-- Table -->
  <nz-spin [nzSpinning]="loading" [nzTip]="'Loading data...'">
    <div class="table-container">
      <nz-table
        [nzData]="notesList"
        [nzBordered]="true"
        [nzSize]="'middle'"
        [nzShowPagination]="false"
      >
        <thead>
          <tr>
            <th nzWidth="40%">Note</th>
            <th>Tags</th>
            <th>Created By</th>
            <th>Created At</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let note of notesList">
            <td>{{ note.note }}</td>
            <td>
              <nz-tag
                *ngFor="let tag of note.tags"
                [nzColor]="tag.color"
                style="margin-right: 4px"
              >
                {{ tag.text }}
              </nz-tag>
            </td>
            <td>
               <span class="user-avatar" style="margin-right: 2px;">
                  {{ note.created_by_name ?   note.created_by_name[0].toUpperCase() : '?' }}
                </span>
                <span class="user-name">
                  {{ note.created_by_name ? note.created_by_name :'&nbsp;-' }}
                </span>
              <!-- {{ note.created_by_name }} -->

            </td>
            <td>{{ note.created_at | date: 'mediumDate' }}</td>
            <td>
              <button nz-button (click)="onEdit(note)" [nzSize]="'small'" class="action-button">
                <i nz-icon nzType="edit"></i>
              </button>
              <button
                nz-button
                nzDanger
                [nzSize]="'small'"
                class="action-button"
                style="margin-left: 10px"
                [nz-popconfirm]="deleteNotePopconfirm"
                [nzPopconfirmTitle]="''"
                [nzPopconfirmOverlayClassName]="'custom-popconfirm-popover'"
                nzPopconfirmPlacement="bottom"
                (nzOnConfirm)="deleteNote(note)"
              >
                <i nz-icon nzType="delete"></i>
              </button>
            <!-- Custom Popconfirm Template for Note Delete -->
            <ng-template #deleteNotePopconfirm>
              <div class="custom-popconfirm-header">
                <span class="custom-popconfirm-title">Confirm Deletion</span>
              </div>
              <div class="custom-popconfirm-icon-area">
                <span style="display: flex; justify-content: center; margin: 18px 0 8px 0;">
                  <nz-icon nzType="warning-fill" nzTheme="fill" style="font-size: 32px; color: #ff6c6c;"></nz-icon>
                </span>
              </div>
              <div class="custom-popconfirm-message description">
                Are you sure you want to delete this note?<br />
                <span style="color:#888; font-size:14px;">This action cannot be undone.</span>
              </div>
              <!-- <div class="custom-popconfirm-actions" style="display: flex; justify-content: flex-end; gap: 8px; margin-top: 16px;">
                <button nz-button nzType="default" nzSize="small" (click)="$event.stopPropagation(); deleteNotePopconfirm.cancel()">Cancel</button>
                <button nz-button nzType="primary" nzDanger nzSize="small" (click)="$event.stopPropagation(); deleteNotePopconfirm.confirm()">OK</button>
              </div> -->
            </ng-template>
            </td>
          </tr>
        </tbody>
      </nz-table>
    </div>
  </nz-spin>
</div>



<nz-modal
  [(nzVisible)]="isVisibleModal"
  [nzTitle]="selectedEditNote ? 'Edit Note' : 'Add Note'"
  (nzOnCancel)="handleModalCancel()"
  (nzOnOk)="onSubmit()"
  [nzOkDisabled]="!form.valid"
>
  <ng-container *nzModalContent>
    <form nz-form [formGroup]="form" nzLayout="horizontal">

      <nz-form-item>
        <nz-form-label>Note</nz-form-label>
        <nz-form-control>
          <textarea
            nz-input
            formControlName="note"
            rows="4"
            placeholder="Enter your note"
          ></textarea>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label>Tag Shortcuts</nz-form-label>
        <nz-form-control>
          <ng-container *ngFor="let shortcut of tagShortcuts">
            <nz-tag
              [nzColor]="shortcut.color"
              style="margin-right: 8px; cursor: pointer"
              (click)="addTagShortcut(shortcut)"
            >
              {{ shortcut.text }}
            </nz-tag>
          </ng-container>
        </nz-form-control>
      </nz-form-item>

      <nz-form-control>
        <div formArrayName="tags">
          <div
            *ngFor="let tagCtrl of tagsFormArray.controls; let i = index"
            [formGroupName]="i"
            style="display: flex; gap: 8px; align-items: center; margin-bottom: 8px"
          >
            <input nz-input formControlName="text" placeholder="Enter tag" />
            <nz-color-picker formControlName="color" nzShowText></nz-color-picker>
            <button
              nz-button
              nzType="text"
              nzDanger
              (click)="removeTag(i)"
              type="button"
            >
              <i nz-icon nzType="close" nzTheme="outline"></i>
            </button>
          </div>
        </div>

        <button nz-button nzType="dashed" (click)="addTag()" type="button">
          <i nz-icon nzType="plus"></i> Add Tag
        </button>
      </nz-form-control>
    </form>
  </ng-container>
</nz-modal>


<nz-modal
  [(nzVisible)]="isVisibleFeedbackModal"
  [nzTitle]="selectedEditFeedback ? 'Edit Feedback' : 'Add Feedback'"
  (nzOnCancel)="handleModalCancelFeedback()"
  (nzOnOk)="onSubmitFeedback()"
  [nzOkDisabled]="!feedbackForm.valid"
>
  <ng-container *nzModalContent>
    <form nz-form [formGroup]="feedbackForm" nzLayout="horizontal">



      <nz-form-item>
        <nz-form-label [nzRequired]="true">Vendor</nz-form-label>
        <nz-form-control>
          <nz-select
          nzShowSearch nzAllowClear
            formControlName="vendor"
            nzPlaceHolder="Select Vendor"
            [nzOptions]="vendorOptions"
          ></nz-select>
        </nz-form-control>
      </nz-form-item>


      <nz-form-item>
        <nz-form-label>Feedback</nz-form-label>
        <nz-form-control>
          <textarea
            nz-input
            formControlName="feedback"
            rows="4"
            placeholder="Enter feedback"
          ></textarea>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label [nzRequired]="true">Star Rating</nz-form-label>
        <nz-form-control>
          <nz-rate
            formControlName="star_rating"
            [nzCount]="5"
            [nzAllowHalf]="true"
          ></nz-rate>
        </nz-form-control>
      </nz-form-item>
    </form>
  </ng-container>
</nz-modal>
